import { render } from "./Property_Statements.vue?vue&type=template&id=539d0214"
import script from "./Property_Statements.vue?vue&type=script&lang=js"
export * from "./Property_Statements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__